import {  t  } from "@/client/libs/dummy-i18n";
import { Card } from "@stackmorph/ui";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router";

import { toast } from "@/client/hooks/use-toast";
import { axios } from "@/client/libs/axios";
import { useUser } from "@/client/services/user";

import { TOTPInput } from "./_components/totp-input";

export const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { user, loading: isLoading } = useUser();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (!isLoading && !user) {
      toast({
        variant: "error",
        title: t`Access Denied`,
        description: t`You must be logged in to access the admin panel.`,
      });
      void navigate("/auth/login");
    }
  }, [user, isLoading, navigate]);

  const handleTOTPComplete = async (code: string) => {
    try {
      const response = await axios.post("/admin/auth/login", {
        code,
      });

      // Store admin token
      localStorage.setItem("adminToken", response.data.adminToken);

      toast({
        variant: "success",
        title: t`Welcome, Admin!`,
        description: t`Authentication successful.`,
      });

      void navigate("/admin/dashboard");
    } catch (error_: any) {
      setError(error_?.response?.data?.message ?? t`Invalid code`);
      toast({
        variant: "error",
        title: t`Authentication Failed`,
        description: t`Invalid TOTP code. Please try again.`,
      });
    }
  };

  if (isLoading || !user) {
    return <div className="flex min-h-screen items-center justify-center">{t`Loading...`}</div>;
  }

  return (
    <>
      <Helmet>
        <title>{t`Admin Login - Stackmorph Resume Builder`}</title>
      </Helmet>

      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-background via-background to-primary/5">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-md p-6"
        >
          <Card className="overflow-hidden border-2 border-primary/20 bg-background/50 p-8 backdrop-blur-sm">
            <div className="mb-8 text-center">
              <h1 className="text-3xl font-bold text-primary">
                {t`Admin Access`}
              </h1>
              <p className="mt-2 text-sm text-muted-foreground">
                {t`Enter your authenticator code`}
              </p>
            </div>

            <TOTPInput error={error} onComplete={handleTOTPComplete} />
          </Card>
        </motion.div>
      </div>
    </>
  );
};
